export const pagePath = 'https://www.jianyanwang.com'
export const reqPath = 'https://www.jianyanwang.com'

// export const pagePath = 'https://www.ujoyhealth.com'
// export const reqPath = 'https://www.ujoyhealth.com'

// export const pagePath = 'https://uat.liferiverai.cn/foreend'
// export const reqPath = 'https://uat.liferiverai.cn/foreend'

 // export const pagePath = 'http://192.168.1.212'
 // export const reqPath = 'http://192.168.1.212:8080'

// export const reqPath = 'http://192.168.10.11:8080'



// WEBPACK FOOTER //
// ./src/util/global.js